import React from "react";

// Chakra imports
import { Flex, Image, Heading, useColorModeValue } from "@chakra-ui/react";

import Logo from "assets/images/logo.png";

export function SidebarBrand() {
  return (
    <Flex align="start" direction="column" p="0" pt="2" pb="2" mt="5">
      <Flex pl="5" gap="4">
        <Image src={Logo} width="150px" height="auto" alt="NCVS" />
      </Flex>
    </Flex>
  );
}

export default SidebarBrand;
